/**
 * Formatting, in one place, so a date never renders two different ways in the same app.
 * Day before month ("28 Oct"), as in every CX frame and sentence (v2 review, 30 Oct).
 */
const LOCALE = 'en-GB';

export const dateTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString(LOCALE, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—';

export const dateOnly = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString(LOCALE, { month: 'short', day: 'numeric' }) : '—';

export const dateLong = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString(LOCALE, { year: 'numeric', month: 'short', day: 'numeric' }) : '—';

export const calendarDate = (iso: string | Date | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString(LOCALE, { month: 'short', day: 'numeric', timeZone: 'UTC' }) : '—';

export const calendarLong = (iso: string | Date | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString(LOCALE, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }) : '—';

/** yyyy-mm-dd for a date input. */
export const dateInput = (d: Date | string | null | undefined) => {
  if (!d) return '';
  const x = typeof d === 'string' ? new Date(d) : d;
  const m = String(x.getMonth() + 1).padStart(2, '0');
  const day = String(x.getDate()).padStart(2, '0');
  return `${x.getFullYear()}-${m}-${day}`;
};
